<script lang="ts">
	import { route } from '$lib/ROUTES'
	import { webLink } from '@helpers/webLink'
	import { _ } from '@repo/i18n'

	interface Props {
		hidePrivacy?: boolean
		affiliateTerms?: boolean
	}

	let { hidePrivacy = false, affiliateTerms = false }: Props = $props()
</script>

<a class="text-link" href={webLink('privacy-policy')} rel="noreferrer" target="_blank">
	{$_('footer.privacy')}
</a>
{#if affiliateTerms}
	<a
		class="text-link"
		href="
  {route('/terms-conditions')}"
		rel="noreferrer"
		target="_blank"
	>
		{$_('footer.terms')}
	</a>
{:else if !hidePrivacy}
	<a class="text-link" href={webLink('terms-conditions')} rel="noreferrer" target="_blank">
		{$_('footer.terms')}
	</a>
{/if}
